const state = {
    acessibilidade:{}
}
export default state